import Constants from '../constants';
const constants = Constants;
export const ConfirmAction = (label,confirm, cancel,callback=null) => { 
    return {
        type: constants.Actions.ConfirmAction.Add,
        confirmObj: {
            label: label,
            confirmAction: confirm,
            cancelAction: cancel,
            callback: callback
        }
    }
}